import { useState, useRef, createContext } from "react"

export const GlobalConfigContext = createContext([{}, () => {}])

export const GlobalConfigProvider = ( props ) => {

    const configSocketRef = useRef();

    const [socketToken, setSocketToken] = useState();
    const [currentUser, setCurrentUser] = useState(null);
    const [currentPage, setCurrentPage] = useState(null);
    const [currentError, setCurrentError] = useState(null);    
    const [currentTextFilter, setCurrentTextFilter] = useState(null);

    return (
        <GlobalConfigContext.Provider value={{
            configSocketRef,     
            socketToken, setSocketToken,       
            currentUser, setCurrentUser,
            currentPage, setCurrentPage,
            currentError, setCurrentError,
            currentTextFilter, setCurrentTextFilter         
        }}>
            {props.children}
        </GlobalConfigContext.Provider>
    )
}